import { motion } from "framer-motion";

const BRANDS = [
  {
    name: "Chai Yoga",
    tagline: "Balance · Breathe · Be Well",
    desc: "Premium loose-leaf chai and herbal infusions, blended for the mindful Indian household.",
    image: "/assets/chai-yoga-logo.png",
    imageMode: "contain", // brand logo — preserve full artwork
    imageBg: "#F4EDDE",
    category: "Tea & Wellness",
  },
  {
    name: "Grain Story",
    tagline: "Honest grains, honest food",
    desc: "Farm-to-pack staples — millets, pulses, and whole grains sourced directly from Indian farmers.",
    image: "/assets/grain-story-logo.png",
    imageMode: "contain",
    imageBg: "#FFFFFF",
    imagePadding: "p-1",
    imageScale: "scale-125",
    category: "Staples & Grains",
  },
  {
    name: "Cookie Magic",
    tagline: "Made with magic, loved everywhere",
    desc: "Artisan baked cookies and indulgent treats — crafted in small batches, with real ingredients.",
    image: "/assets/cookie-magic-logo.png",
    imageMode: "contain",
    imageBg: "#FFFFFF",
    category: "Bakery & Treats",
  },
  {
    name: "Bloody Bubbly",
    tagline: "Mix it. Pour it. Own the night.",
    desc: "Bold, ready-to-pour cocktail mixers and craft beverages — designed for the modern Indian host.",
    image: "/assets/bloody-bubbly-logo.png",
    imageMode: "contain",
    imageBg: "#000000",
    imagePadding: "p-8",
    category: "Beverages & Mixers",
  },
];

export default function FmcgBrands() {
  return (
    <section
      id="fmcg-brands"
      data-testid="fmcg-brands-section"
      className="bg-[#FAFAF7] py-24 md:py-32"
    >
      <div className="cgp-container">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="flex flex-col md:flex-row md:items-end md:justify-between gap-10"
        >
          <div className="max-w-2xl">
            <span className="cgp-overline">Division 02 — FMCG Brand House</span>
            <h2 className="font-serif font-light text-[#0A1F44] mt-6 text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
              Brands built with
              <br />
              <span className="italic text-[#0A1F44]/70">
                taste, story &amp; soul.
              </span>
            </h2>
          </div>
          <p className="max-w-md text-[#0B1A36]/70 leading-relaxed">
            Catalyst incubates and partners with consumer brands that we believe
            in — modern Indian businesses with strong unit economics and even
            stronger storytelling.
          </p>
        </motion.div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {BRANDS.map((b, i) => (
            <motion.article
              key={b.name}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              data-testid={`brand-card-${b.name.toLowerCase().replace(/\s+/g, "-")}`}
              className="group bg-white border border-[#0A1F44]/8 overflow-hidden cgp-card-hover"
            >
              <div
                className="relative h-72 overflow-hidden"
                style={
                  b.imageBg ? { backgroundColor: b.imageBg } : undefined
                }
              >
                <img
                  src={b.image}
                  alt={b.name}
                  className={`w-full h-full transition-transform duration-700 group-hover:scale-105 ${
                    b.imageMode === "contain"
                      ? `object-contain ${b.imagePadding || "p-6"} ${b.imageScale || ""}`
                      : "object-cover"
                  }`}
                />
                <span className="absolute top-4 left-4 bg-white/95 backdrop-blur text-[10px] uppercase tracking-[0.25em] px-3 py-1.5 text-[#0A1F44] font-semibold">
                  {b.category}
                </span>
              </div>
              <div className="p-7 md:p-8">
                <h3 className="font-serif text-2xl text-[#0A1F44]">{b.name}</h3>
                <p className="text-[#C8A24A] uppercase tracking-[0.18em] text-[10px] mt-2 font-semibold">
                  {b.tagline}
                </p>
                <span className="cgp-gold-rule mt-4" />
                <p className="text-[#0B1A36]/70 mt-4 leading-relaxed text-sm">
                  {b.desc}
                </p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
